// extracted by mini-css-extract-plugin
export default {"wellDone":"WellDone_wellDone__-m2ri","praise":"WellDone_praise__8TvAj","lottieContainer":"WellDone_lottieContainer__Bq-I1","lottie":"WellDone_lottie__uhWQT"};